import { cloudflareClient } from "better-auth-cloudflare";
import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
export const authClient = createAuthClient({ plugins: [cloudflareClient(), inferAdditionalFields({
    user: {
        customerId: {
            type: 'string',
            required: false
        },
        onboardingComplete: {
            type: 'boolean',
            required: false
        },
        onboardingStep: {
            type: 'number',
            required: false
        }
    }
})] })

export const { 
  signIn, 
  signOut, 
  signUp, 
  useSession,
  updateUser,
  changePassword,
  forgetPassword,
  resetPassword
} = authClient;


